import React from 'react'
import { withRouter } from "react-router-dom";
import { FormComponent } from '../../../components/form/DynamicForm';
import { Form, Validators } from '../../../components/form/DynamicFormTs';
import Http from '../../../Http';
import { Button, CircularProgress, Slide, Snackbar } from '@material-ui/core';
import Toast from 'react-hot-toast';

class Llegada extends FormComponent {

  componentDidMount() {
    this.setState({ loading: true });
    const sucursales = this.props.sucursales ? this.props.sucursales.map(row => ({ Value: row.id, Label: row.sucursal })) : [];
    this.FormConfig(
      { defaultUrl: 'embarque/one', saveUrl: '', backUrl: '' },
      new Form([
        Form.FieldL('text', 'id', 'Embarque', '', [Validators.required], 4, [], true),
        Form.Field('select', 'id_sucursal_llegada', 'Marcar llegada en Sucursal', `${this.props.id_sucursal}`, [Validators.required], 4, sucursales, [], [], false, true),
        Form.Field('date-hour', 'llegada_fecha', 'Fecha y hora', new Date(), [Validators.required], 4, [], [], [], false, true),
        Form.Field('text', 'tractor', 'Tractor', '', [Validators.required], 4, [], [], [], false, true),
        Form.Field('text', 'caja', 'Caja', '', [Validators.required], 4, [], [], [], false, true),
        Form.Field('text', 'sello', 'Sello', '', [Validators.required], 4, [], [], [], false, true),
      ], ['Registrar llegada'], 'Registro de llegadas')
    )
    // if (this.props.match.params.id)
    this.LoadPreds(this.props.id).then(() => {
      this.setState({ loading: false });
    })
  }

  LoadPreds = async (predId = null) => {
    let id = predId ? predId : this.props.match.params.id;
    let Res = await Http.get(`embarque/one/${id}`);
    if (!Res.error) {
      if (!Res.data.llegada_fecha) delete Res.data.llegada_fecha;
      this.setState({ FormData: Form.Patch(this.state.FormData, Res.data, true) })
    }
  }

  onSubmit = async (i, vals) => {
    vals.id = this.props.id;
    try {
      this.setState({ loading: true });
      let Res = await Http.post(`embarque/llegada`, { embarque: vals });
      if (!Res.error) {
        let guiasDesembarcadas = 'Se desembarcaron las siguientes guias: ';
        if (Res.data && Res.data.GuiasEmbarqueSave) {
          Res.data.GuiasEmbarqueSave.forEach(guia => {
            guiasDesembarcadas = `${guiasDesembarcadas} ${guia.g_folio}`
          });
        }
        Toast.success(`Guardado. ${guiasDesembarcadas}`)
        this.setState({ loading: false, correctSave: true });
      } else {
        Toast.error(Res.errMsg)
        this.setState({ loading: false });
      }
    } catch (error) {
      Toast.error('Error Inesperado (100)')
      this.setState({ loading: false });
    }
  }

  onContinue = (continues) => {
    this.props.onSave({ continue: continues });
  }

  render() {
    const { loading, correctSave = false } = this.state;
    return (
      <div>
        {
          loading ? <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', padding: 30 }} >
            <CircularProgress />
            <div>Cargando...</div>
          </div>
            : <this.FormRender />
        }
        {
          correctSave &&
          <div className='bg-success' style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 10 }} >
            <div style={{ fontWeight: 'bolder' }}>Se Marco llegada Corectamente, Aún se necesita marcar la Guias Desembarcadas</div>
            <div>
              <Button style={{ marginRight: 10 }} variant="contained" color='primary' onClick={() => { this.onContinue(false) }} >Cerrar</Button>
              <Button variant="contained" color='secondary' onClick={() => { this.onContinue(true) }} >Continuar con Desembarque de Guias</Button>
            </div>
          </div>
        }
      </div>
    )
  }
}

export default withRouter(Llegada)
